import {object, string} from "yup";
import {account$} from "../../../../emitters/account";
import {replaceLocation} from "../../../../router";
import {LINK_SIGN_IN} from "../../../../constants/links";
import {LayoutAuthWithForm} from "../../../layouts";
import {MerchantInputCode} from "../../../helpers/InputsHelpers";
import React from "react";
import {openPopupInfo} from "../../../../emitters/popup";
import {Box} from "@material-ui/core";
import ResendVerification from "./components/ResendBtn";

export default (props) => {
  const email = decodeURIComponent((props.params || {}).email || '');

  const schema = object({code: string().length(6, 'Code must be exactly 6 characters').required()});

  const onSubmit = (params) => account$.emailConfirm(params);
  const onResult = () => {
    replaceLocation({
      path: LINK_SIGN_IN,
    });
    openPopupInfo(['Email has been verified', 'Please log in to continue.']);
  };

  return (
    <LayoutAuthWithForm
      title="Security verification"
      formProps={{schema, onSubmit, onResult}}
      content={(formCtx) => (
        <>
          <MerchantInputCode
            label="Verification code"
            name="code"
            formCtx={formCtx}
            codeLength={6}
          />
          <Box mt="4rem">
            Please enter the activation code we sent you to the email address <b>{email}</b>
          </Box>
        </>
      )}
      submitBtnText="Send"
      additional={(
        <ResendVerification email={email} />
      )}
    />
  );
}
